var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tnc-wrapper" },
    [
      _vm._m(0),
      _vm._m(1),
      _vm._m(2),
      _vm._m(3),
      _vm._m(4),
      _vm._m(5),
      _vm._m(6),
      _vm.isMobile ? _c("BurgerMenu") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h2", [
      _c("span", { staticStyle: { "font-size": "16pt" } }, [
        _vm._v("Shartlar va qoidalar"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", [
      _c("strong", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("Umumiy qoidalar"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Bizning veb-saytimiz faqat shaxs yashaydigan hududda belgilangan voyaga yetgan shaxslar uchun mo'ljallangan. "
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Bizning veb-saytimiz veb-saytimizdan foydalanuvchi har qanday foydalanuvchilar tomonidan buzilgan biron bir milliy qonun, federal qonun yoki xalqaro qonunlar uchun javobgar emas. "
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Foydalanuvchilar o'z harakatlari uchun javobgardirlar va o'z mamlakatlari qonunlariga, jumladan, shtat qonunlariga yoki huquqiy masalalarga bo'ysunadilar."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Barcha agentlar o'z a'zolarining hisoblari uchun javobgardirlar va ular tomonidan taqdim etilgan barcha tasdiqlangan garovlarni hisobga olishlari shart."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Agentlar bizning veb-saytimizning hamkorlari emas. Shuning uchun bizning veb-saytimiz o'yinchilar va agentlar o'rtasidagi har qanday kelishmovchiliklar yoki nizolar uchun javobgar emas."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Foydalanuvchi identifikatori va parolini ruxsatsiz foydalanishdan himoya qilish foydalanuvchining zimmasidadir. Agar foydalanuvchi identifikatori va paroli o'g'irlangan yoki buzilgan bo'lsa, darhol agentiga murojaat qilish foydalanuvchining zimmasidadir. Keyin agent foydalanuvchi identifikatori va parolini o'zgartiradi."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Foydalanuvchi identifikatori va paroli o'g'irlangan taqdirda, foydalanuvchi o'z hisoblari uchun javobgar bo'ladi va taqdim etilgan barcha tasdiqlangan garovlarni hisobga oladi."
              ),
            ]),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", [
      _c("strong", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("O'yin qoidalari"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Veb-saytimiz tomonidan hal qilinadigan o'yin natijalari yakuniy va majburiy hisoblanadi."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Barcha nizoli holatlarda, veb-saytimiz rahbariyati ham, o'yinchi ham veb-saytimizdagi tranzaksiyalar jurnali ma'lumotlar bazasi nizoda yakuniy hakam bo'lib xizmat qilishiga rozi bo'lishlari kerak. Barcha nizolar o'yin natijasi aniqlangan kun ichida berilishi kerak. O'yin kunidan keyin hech qanday da'volar ko'rib chiqilmaydi."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "O'yinchi o'z hisobidagi barcha tranzaksiyalarning to'g'riligini tekshirish uchun to'liq javobgardir."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Kompyuter orqali garovlaringizni yuborishdan oldin, ularni xatolar, xatolar yoki kamchiliklar uchun tekshirib ko'ring. Garov kompyuter orqali qabul qilingandan so'ng, uni o'zgartirish yoki bekor qilish mumkin emas."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Biz ushbu Shartlar va Qoidalarni buzgan, firibgarlik faoliyati bilan shug'ullangan, ruxsatsiz kirishgan, hujum qilgan, soxtalashtirgan, standart qoidalarni buzgan yoki sindikat pul tikishda ishtirok etgan har qanday mijozning hisobini muzlatish yoki bekor qilish huquqini o'zida saqlab qolamiz, natijada yuzaga kelgan barcha hisob qoldiqlari oldindan ogohlantirmasdan muzlatiladi va musodara qilinadi."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Biz sindikat garovlari, kelishilgan garovlar, til biriktirish, firibgarlik, tizimni suiiste'mol qilish, texnik xatolardan foydalanish, noto'g'ri koeffitsientlar yoki adolatsiz ustunlikka erishishga qaratilgan boshqa har qanday urinish bilan bog'liq deb topilgan har qanday garov yoki chiptani bekor qilish yoki bekor qilish huquqini o'zida saqlab qolamiz. Tegishli har qanday yutuqlar bekor qilinishi mumkin va tegishli hisob to'xtatib qo'yilishi yoki tugatilishi mumkin."
              ),
            ]),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", [
      _c("strong", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("Limitlar va majburiyatlar"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Yuqoridagilarning umumiy mazmuniga putur yetkazmasdan, veb-saytimiz sabotaj, fors-major holatlari va/yoki veb-saytimizning markaziy kompyuter tizimi yoki yozuvlari yoki uning biron bir qismining ishdan chiqishi, shikastlanishi yoki yo'q qilinishi, yoki biron bir telekommunikatsiya yoki biron bir ma'lumot uzatish tizimining ishdan chiqishi natijasida yuzaga kelgan kechikishlar, yo'qotishlar, xatolar, kamchiliklar yoki boshqa holatlar yoki ma'lum bir poyga uchun biron bir ariza qabul qilinmasligiga olib kelgan kechikish holatlari uchun hech kim oldida javobgar bo'lmaydi."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Bizning veb-saytimiz Xudoning o'zi tomonidan sodir etilgan har qanday falokat, harbiy harakatlar, tartibsizliklar, fuqarolar tartibsizliklari, terrorizm harakati, hukumat yoki hokimiyat harakati (shu jumladan, har qanday litsenziya yoki rozilikni rad etish yoki bekor qilish), yong'in, portlash, suv toshqini, o'g'irlik, qasddan qilingan zarar, ish tashlash, lokavt va har qanday turdagi sanoat harakatlari natijasida yuzaga kelgan har qanday yo'qotish uchun javobgar bo'lmaydi."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Tarmoq ulanishi, aloqa, tizim yoki inson xatolari natijasida garov bilan bog'liq muammolar yuzaga kelgan taqdirda, masalan, qo'shaloq garovlar qabul qilinishi, garovlar tasdiqlanmasligi, o'yin boshlanganidan keyin garovlar qo'yish va hokazo. Bunday xatolar yuzaga kelgan taqdirda, biz ularni har bir holat bo'yicha alohida hal qilish va bunday xatolarni tuzatish uchun boshqa har qanday choralarni ko'rish huquqini o'zida saqlab qolamiz. Bunday xatolar bo'yicha biz siz yoki biron bir uchinchi shaxs oldida hech qanday javobgarlikni o'z zimmamizga olmaymiz. Agar siz bunday xatolarga duch kelgan bo'lsangiz va yuqori lavozimdagi xodimingizga xabar bermasdan garov tikishda davom etsangiz, xatolar yana takrorlansa, siz javobgar bo'lasiz va barcha yutuq/mag'lubiyat natijalarini hurmat qilasiz."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Ushbu Qoidalar va Nizomlar tomonlar o'rtasidagi to'liq kelishuv va o'zaro tushunishni tashkil qiladi."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Agar ushbu Qoidalar va Nizomlarning ingliz tilidagi versiyasi bilan boshqa har qanday til versiyasi o'rtasida biron bir tafovut bo'lsa, ingliz tilidagi versiyasi boshqa tillarning o'rnini bosadi va to'g'ri va haqiqiy deb hisoblanadi."
              ),
            ]),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }